import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import { createContext, useContext } from 'react';

const DeviceContext = createContext(null);
const DeviceProvider = ({ userAgent, children, }) => {
    return (jsxRuntimeExports.jsx(DeviceContext.Provider, { value: userAgent, children: children }));
};
const useDeviceContext = () => {
    const context = useContext(DeviceContext);
    if (context === null) {
        throw new Error('useDeviceContext must be used within a DeviceProvider');
    }
    return context;
};

export { DeviceProvider, useDeviceContext };
//# sourceMappingURL=DeviceProvider.js.map
